import React, { useState, useEffect } from 'react';
import {
  Button, Col, notification, Row, Empty,
} from 'antd';
import { useMutation, useQuery } from '@apollo/client';
import ContainerHeader from '../../../components/containerHeader';
import Cohorts from './cohorts';
import { GET_ALL_COHORT, CREATE_COHORT } from '../../../graphql';
import ViewSpinner from '../../../components/viewSpinner/ViewSpinner';
import AddCohortModal from './addCohort';

export default () => {
  const { data: cohortPayload, loading: cohortLoading } = useQuery(GET_ALL_COHORT);
  const [addCohort, { data: addCohortRes, loading: addCohortLoading }] = useMutation(CREATE_COHORT);
  const [cohorts, setCohort] = useState([]);
  const [showAddCohort, setShowAddCohort] = useState(false);
  useEffect(() => {
    if (!cohortLoading && cohortPayload) {
      setCohort([...cohortPayload.cohorts].reverse());
    }
  }, [cohortLoading, cohortPayload]);

  const handleAddCohort = async (payload) => {
    const { name, description } = payload;
    try {
      // `createdBy` comes from the token rather than a nested connect.
      await addCohort({
        variables: { input: { name, description } },
        update: (proxy, { data: { createCohort: created } }) => {
          const existing = proxy.readQuery({ query: GET_ALL_COHORT });
          if (!existing) return;
          proxy.writeQuery({
            query: GET_ALL_COHORT,
            data: { cohorts: [...existing.cohorts, created] },
          });
        },
      });
    } catch (error) {
      notification.error({
        message: 'Error, something went wrong',
        description: error.message || 'Could not add cohort',
      });
    }
  };

  useEffect(() => {
    if (!cohortLoading && addCohortRes) {
      notification.success({ message: 'New Cohort Added', description: "You've successfully created a new cohort" });
      setShowAddCohort(false);
    }
  }, [cohortLoading, addCohortRes]);
  return (
    <div>
      <AddCohortModal
        handleAddCohort={handleAddCohort}
        visible={showAddCohort}
        addLoading={addCohortLoading}
        handleCancel={() => setShowAddCohort(!showAddCohort)}
      />
      <div className="gx-d-flex gx-flex-row-reverse gx-w-100 ">
        <Button type="primary" onClick={() => setShowAddCohort(!showAddCohort)}>New Cohort</Button>
      </div>
      <Row className="gx-mb-3">
        <Col span={24}>
          <ContainerHeader title="Cohorts" />
        </Col>
        {!cohortLoading && <Cohorts cohorts={cohorts} />}
        {!cohortLoading && cohortPayload && cohorts.length < 1 && (
          <Col span={24}>
            <Empty description="No cohort created yet" />
          </Col>
        )}
        {cohortLoading && <ViewSpinner />}
      </Row>
    </div>
  );
};
